import {
  PMMDocument,
  PMMScriptWritten,
  type CareProgressRowData,
} from '../../../Table/components/CareProgress/types';

export enum AdditionalSectionKeys {
  ADMISSION_DETAILS = 'Admission details',
  MEDICATION_DETAILS = 'Medication details',
  CARE_PROGRESS = 'Care progress',
}

export enum EditType {
  TEXT = 'text',
  DATE = 'date',
}

export const CombinedTypes = ['eGFR'];

export const PMMDocumentTypes = [
  ...Object.values(PMMDocument),
  ...Object.values(PMMScriptWritten),
  'Med. profile',
];

export const DateTypes = [
  'Date admitted',
  'Planned D/C',
  'EMR Estimated D/C Date',
];
export enum ValueType {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  OPTIONS = 'options',
}

export interface SectionField {
  editType: ValueType;
  editable: boolean;
  formatType: string;
  key: string;
  title: string;
  field?: string;
  options?: { label: string; value: string }[];
}

export interface PatientContactSectionField extends SectionField {
  formatType: 'contactName' | 'contactPhone' | 'contactEmail' | 'relationship';
}

export enum PatientEpisodeDetailsNames {
  Weight = 'weight',
  EGFR = 'eGFR',
  Height = 'height',
  EMRAdmissionReason = 'EMR Admission reason',
  AdmissionReason = 'Admission reason',
  GoalOfAdmission = 'Goal of admission',
  LengthOfStay = 'Length of stay',
  PlannedDC = 'Planned D/C',
  DateAdmitted = 'Date admitted',
  EMREstimatedDcDate = 'EMR Estimated D/C Date',
  PrevAdmission = 'Prev. admission',
  RouteModifiers = 'Route modifiers',
  MedicationDiet = 'Medication diet',
  EstimatedGlomerularFiltrationRate = '.Estimated Glomerular Filtration Rate',
}

export type AdditionalSectionValue = {
  value: AdditionalDataValue;
  trend?: number;
  dateStr?: string;
};

export type AdditionalDataValue =
  | string
  | number
  | Date
  | CareProgressRowData[];
